import React, { forwardRef, useState } from 'react'

import IconInput from '../IconInput/IconInput'
import Input from '../Input/Input'

export type PasswordInputProps = React.ComponentProps<typeof Input> & {
  CustomInput?: React.ComponentType<React.ComponentProps<typeof Input>>
  customInputProps?: Record<string, unknown>
  showPasswordLabel: string
  hidePasswordLabel: string
}

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ showPasswordLabel, hidePasswordLabel, type, ...props }, ref) => {
    const [isMasked, setMasked] = useState(true)
    const unmaskedType = type == null || type === 'password' ? 'text' : type
    return (
      <IconInput
        {...props}
        type={isMasked ? 'password' : unmaskedType}
        icon={isMasked ? 'eyeClosed' : 'eyeOpen'}
        iconLabel={isMasked ? showPasswordLabel : hidePasswordLabel}
        onIconClick={() => setMasked(value => !value)}
        ref={ref}
      />
    )
  }
)

export default PasswordInput
